import { createSyncStore } from '../factory';

type LocationsState = {
  selectedLocationIds: string[];
};

type LocationsActions = {
  setSelectedLocationIds: (ids: string[]) => void;
};

/**
 * Synced store for selected location IDs that the renderer pushes to the shell
 * (Electron main process) and the shell persists to `manageState`.
 *
 * Replaces the old `shell.emit('send:locations', ...)` IPC pattern.
 *
 * The renderer sets `selectedLocationIds` via
 * `useShellLocationsSyncStore.getState().setSelectedLocationIds(ids)`.
 *
 * The shell subscribes via
 * `shellBridge.subscribe('locations', cb, ['selectedLocationIds'])` to persist changes.
 *
 * Channel: `locations`
 */
export const useShellLocationsSyncStore = createSyncStore<LocationsState, LocationsActions>({
  channel: 'locations',
  syncKeys: ['selectedLocationIds'],
  throttleMs: 50,

  state: {
    selectedLocationIds: [],
  },

  actions: (set) => ({
    setSelectedLocationIds: (ids: string[]) => set({ selectedLocationIds: ids }),
  }),
});
